import * as React from "react";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CardMedia from "@mui/material/CardMedia";
import Chip from "@mui/material/Chip";
import SeoHelmet from "../components/SeoHelmet";
import "./TechCorner.css";
import financeInternIcon from "../static/finance_intern.png";
import autoTabOpenerIcon from "../static/auto_tab_opener.png";
import birthdayReminderIcon from "../static/birthday_reminder.png";
import euribotIcon from "../static/euribot.png";
import { CardActionArea } from "@mui/material";

const TechCorner = () => {
    const navigate = useNavigate();
    const goToFinanceIntern = (newTab) => {
        ReactGA.event({
            category: "FinanceIntern",
            action: "User pressed FinanceIntern",
        });
        window.open(
            "https://play.google.com/store/apps/details?id=com.financeintern&utm_source=instanceof",
            newTab ? "_blank" : "_self"
        );
        // navigate('/tech-corner/finance-intern');
    };

    const goToAutoTabOpener = (newTab) => {
        ReactGA.event({
            category: "AutoTabOpener",
            action: "User pressed AutoTabOpener",
        });
        navigate("/tech-corner/auto-tab-opener");
    };

    const goToBirthdayReminder = (newTab) => {
        ReactGA.event({
            category: "BirthdayReminder",
            action: "User pressed BirthdayReminder",
        });
        navigate("/tech-corner/birthday-reminder");
    };

    const goToEuribot = (newTab) => {
        ReactGA.event({
            category: "Euribot",
            action: "User pressed Euribot",
        });
        window.open(
            "https://twitter.com/TheEuribot?utm_source=instanceof",
            newTab ? "_blank" : "_self"
        );
        // navigate('/tech-corner/euribot');
    };

    return (
        <div className="Container">
            <SeoHelmet
                title="InstanceOf | TechCorner"
                description="InstanceOf | The Tech Corner of Nuno Reis"
            />
            <Navbar />

            <main className="Centered-Content TechCorner-content">
                <header className="TechCorner-heading">
                    <Typography
                        component="h1"
                        variant="h4"
                        className="TechCorner-title"
                    >
                        Tech Corner
                    </Typography>
                </header>

                <div className="TechCorner-grid">
                    <Card className="TechCorner-card" variant="outlined">
                        <CardActionArea
                            className="TechCorner-card-action"
                            onClick={() => goToBirthdayReminder()}
                            onAuxClick={() => goToBirthdayReminder(true)}
                        >
                            <CardMedia
                                component="img"
                                className="TechCorner-card-image"
                                alt=""
                                src={birthdayReminderIcon}
                            />
                            <Box className="TechCorner-card-copy">
                                <CardContent>
                                    <Typography
                                        component="div"
                                        variant="h5"
                                        className="TechCorner-card-title"
                                    >
                                        Birthday Reminder
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        component="div"
                                        className="TechCorner-card-description"
                                    >
                                        Helps users keep track of the birthdays of
                                        their friends and family.
                                    </Typography>
                                </CardContent>
                            </Box>
                        </CardActionArea>
                    </Card>
                    <Card className="TechCorner-card" variant="outlined">
                        <CardActionArea
                            className="TechCorner-card-action"
                            onClick={() => goToAutoTabOpener()}
                            onAuxClick={() => goToAutoTabOpener(true)}
                        >
                            <CardMedia
                                component="img"
                                className="TechCorner-card-image"
                                alt=""
                                src={autoTabOpenerIcon}
                            />
                            <Box className="TechCorner-card-copy">
                                <CardContent>
                                    <Typography
                                        component="div"
                                        variant="h5"
                                        className="TechCorner-card-title"
                                    >
                                        Automatic Tab Opener
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        component="div"
                                        className="TechCorner-card-description"
                                    >
                                        Open multiple tabs periodically based on a
                                        cron expression
                                    </Typography>
                                </CardContent>
                            </Box>
                        </CardActionArea>
                    </Card>
                    <Card className="TechCorner-card" variant="outlined">
                        <CardActionArea
                            className="TechCorner-card-action"
                            onClick={() => goToFinanceIntern()}
                            onAuxClick={() => goToFinanceIntern(true)}
                        >
                            <CardMedia
                                component="img"
                                className="TechCorner-card-image"
                                alt=""
                                src={financeInternIcon}
                            />
                            <Box className="TechCorner-card-copy">
                                <CardContent>
                                    <Typography
                                        component="div"
                                        variant="h5"
                                        className="TechCorner-card-title"
                                    >
                                        Finance Intern
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        component="div"
                                        className="TechCorner-card-description"
                                    >
                                        Multiple financial calculators to aid you
                                        with everyday life
                                    </Typography>
                                </CardContent>
                            </Box>
                        </CardActionArea>
                    </Card>
                    <Card className="TechCorner-card" variant="outlined">
                        <CardActionArea
                            className="TechCorner-card-action"
                            onClick={() => goToEuribot()}
                            onAuxClick={() => goToEuribot(true)}
                        >
                            <CardMedia
                                component="img"
                                className="TechCorner-card-image TechCorner-euribot-image"
                                alt=""
                                src={euribotIcon}
                            />
                            <Box className="TechCorner-card-copy">
                                <CardContent>
                                    <Chip
                                        label="Deprecated"
                                        size="small"
                                        className="TechCorner-status"
                                    />
                                    <Typography
                                        component="div"
                                        variant="h5"
                                        className="TechCorner-card-title"
                                    >
                                        Euribot
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        component="div"
                                        className="TechCorner-card-description"
                                    >
                                        Previously shared Euribor rate
                                        information on Twitter.
                                    </Typography>
                                </CardContent>
                            </Box>
                        </CardActionArea>
                    </Card>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default TechCorner;
